'use strict';

/*global app*/
/*global services*/
/*global createObjectCallBack*/
/*global blockElement*/

function TransferNote(containerId, requestedConfirmSearchValue) {
  this.containerId = containerId;
  this.$container = null;
  this.$form = null;

  this.requestedConfirmSearchValue = requestedConfirmSearchValue;
  this.isConfirmedSubmitForm = false;

  this.init();
}

TransferNote.prototype = $.extend({}, {
  constructor: 'TransferNote',

  registerCallbacks: function registerCallbacks() {
    var _this = this;

    _this.$form.on('submit', function () {
      if (_this.requestedConfirmSearchValue && !_this.isConfirmedSubmitForm) {
        _this.submitForm();

        return false;
      }

      if (!services.get('internet-connection-manager').isOnline()) {
        app.internetConnectionManager.viewOfflineWarning();

        return false;
      }

      blockElement(_this.$form);
    });

    _this.$container.on('click', '.transfer-form__btn', function () {
      if (!app.internetConnectionManager.isOnline()) {
        app.internetConnectionManager.viewOfflineWarning();

        return false;
      }
    });
  },

  //----------------------------------------------------------------------------

  confirmSubmitForm: function confirmSubmitForm() {
    var _this = this;

    var confirm = services.get('confirm');
    confirm.close();

    _this.isConfirmedSubmitForm = true;
    _this.$form.submit();

    return _this;
  },

  submitForm: function submitForm() {
    var _this = this;

    var confirm = services.get('confirm');
    confirm.open({
      title: app.t('transfer_note.title'),
      confirmCallBack: createObjectCallBack(_this, 'confirmSubmitForm'),
      buttonsSize: 'lg',
      width: 'md',
      content: app.t('transfer_note.scanned_location').replace('{location}', _this.$form.find('.search__input').val())
    });

    return _this;
  },

  //----------------------------------------------------------------------------

  init: function init() {
    var _this = this;

    _this.$container = $('#' + _this.containerId);
    _this.$form = _this.$container.find('form');

    _this.registerCallbacks();

    return _this;
  }
});
